<!--
 * @Description  :
 * @Version      : 2.0
 * @Autor        : fangzheng
 * @Date         : 2021-09-03 14:29:48
 * @LastEditors  : fangzheng
 * @LastEditTime : 2021-11-24 18:17:52
-->
<template>
  <div>
    <div class="text-contion" v-for="(item, index) in coReqVos" :key="index">
      <el-button
        v-if="index === 0 && !disabled"
        class="btn"
        type="danger"
        icon="el-icon-plus"
        size="mini"
        circle
        @click="addBtn"
      ></el-button>
      <el-button
        v-if="index !== 0 && !disabled"
        class="btn"
        type="danger"
        icon="el-icon-minus"
        size="mini"
        circle
        @click="deleteBtn(index)"
      ></el-button>
      <el-form ref="item" :model="item" label-width="125px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="需结转组织">
              <div
                class="cost-select"
                @click="openHandleClick('org', 'org_list1', 'orgCode', index)"
              >
                <div
                  class="cost-select1 el-textarea el-input--small"
                  style="min-height: 32px"
                >
                  <el-tag
                    class="tag_box"
                    v-for="(item1, index1) in item.orgReqVos"
                    :key="index1"
                    closable
                    @close="handleClose(item1, index)"
                    >{{ item1.orgName }}</el-tag
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转结财年">
              <el-select
                v-model="item.coBudgetYear"
                multiple
                placeholder="转结财年"
              >
                <el-option
                  v-for="item in fiscalYearArrList"
                  :key="item.dictCode"
                  :label="item.dictValue"
                  :value="item.dictCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转结预算科目">
              <div
                class="cost-select"
                @click="
                  openHandleClick(
                    'budget',
                    'budget_list',
                    'budgetSubjectsCode',
                    index
                  )
                "
              >
                <el-input
                  :readonly="true"
                  v-model="item.coBudgetSubjectName"
                  placeholder="转结预算科目"
                ></el-input>
                <div class="clear-icon" v-if="!disabled">
                  <i
                    class="el-icon-circle-close"
                    @click="clearFn($event, 'budget', index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-row> </el-row>
          <el-col :span="24">
            <el-form-item label="转结公司主体">
              <div
                class="cost-select"
                @click="
                  openHandleClick(
                    'company',
                    'company_list',
                    'companyCode',
                    index
                  )
                "
              >
                <el-input
                  :readonly="true"
                  v-model="item.coCompanyName"
                  placeholder="转结公司主体"
                ></el-input>
                <div class="clear-icon" v-if="!disabled">
                  <i
                    class="el-icon-circle-close"
                    @click="clearFn($event, 'company', index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转入组织">
              <div
                class="cost-select"
                @click="
                  openHandleClick(
                    'unionOrg',
                    'org_list2',
                    'orgCode',
                    index
                  )
                "
              >
                <el-input
                  :readonly="true"
                  v-model="item.unionOrgName"
                  placeholder="转入组织"
                ></el-input>
                <div class="clear-icon" v-if="!disabled">
                  <i
                    class="el-icon-circle-close"
                    @click="clearFn($event, 'unionOrg', index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import request from '../../../../../../utils/request';

export default {
  components: {
    SelectConfig,
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.coReqVos = val;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      fiscalYearArrList: [],
      coReqVos: [{}],
      index: null,
      chooseModule: null,
    };
  },
  props: {
    value: Array,
    disabled: Boolean,
  },
  created() {
    this.getyesOrNoData();
  },
  mounted() {},
  methods: {
    // 打开点击弹窗
    openHandleClick(module, list, key, index, requestType = 'POST') {
      if (this.disabled) {
        return;
      }
      this.index = index;
      this.chooseModule = module;
      let params = {};
      if (module === 'org') {
        params = {
          functionCode: list,
          data: this.coReqVos[index].orgReqVos,
          idKey: 'orgCode',
          paramData: {
            enableStatus: '009',
          },
          requestType,
          noReset: true,
        };
      } else if (module === 'budget') {
        params = {
          functionCode: list,
          data: [],
          idKey: 'id',
          paramData: {},
          requestType,
        };
      } else if (module === 'company') {
        params = {
          functionCode: list,
          data: [],
          idKey: 'id',
          paramData: {},
          requestType,
        };
      } else if (module === 'unionOrg') {
        params = {
          functionCode: list,
          data: [],
          idKey: 'id',
          paramData: {
            enableStatus: '009',
          },
          requestType,
        };
      } else {
        params = {
          functionCode: list,
          data: [],
          idKey: key,
          paramData,
          requestType,
        };
      }
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 获取弹窗选中数据
    onGetSelect(data) {
      const { index } = this;
      if (this.chooseModule === 'org') {
        let dataList = data;
        dataList = dataList.map((v) => {
          const obj = v;
          return {
            orgCode: obj.orgCode,
            orgName: obj.orgName,
          };
        });
        this.coReqVos[index].orgReqVos = dataList;
      } else if (this.chooseModule === 'budget') {
        if (data.length > 0) {
          this.coReqVos[index].coBudgetSubjectName = data[0].budgetSubjectsName; // 组织编码
          this.coReqVos[index].coBudgetSubjectCode = data[0].budgetSubjectsCode; // 组织名称
        } else {
          this.coReqVos[index].coBudgetSubjectName = null;
          this.coReqVos[index].coBudgetSubjectCode = null;
        }
      } else if (this.chooseModule === 'company') {
        if (data.length > 0) {
          this.coReqVos[index].coCompanyName = data[0].companyName; // 组织编码
          this.coReqVos[index].coCompanyCode = data[0].companyCode; // 组织名称
        } else {
          this.coReqVos[index].coCompanyName = null;
          this.coReqVos[index].coCompanyCode = null;
        }
      } else if (this.chooseModule === 'unionOrg') {
        if (data.length > 0) {
          this.coReqVos[index].unionOrgName = data[0].orgName; // 组织编码
          this.coReqVos[index].unionOrgCode = data[0].orgCode; // 组织名称
        } else {
          this.coReqVos[index].unionOrgName = null;
          this.coReqVos[index].unionOrgCode = null;
        }
      }
      this.$emit('input', this.coReqVos);
    },
    // 清除数据
    clearFn(e, code, index) {
      e.stopPropagation();
      if (code === 'org') {
        this.coReqVos[index].orgReqVos = [];
      } else if (code === 'budget') {
        this.coReqVos[index].coBudgetSubjectName = null;
        this.coReqVos[index].coBudgetSubjectCode = null;
      } else if (code === 'company') {
        this.coReqVos[index].coCompanyName = null;
        this.coReqVos[index].coCompanyCode = null;
      } else if (code === 'unionOrg') {
        this.coReqVos[index].unionOrgName = null;
        this.coReqVos[index].unionOrgCode = null;
      }
      this.$emit('input', this.coReqVos);
    },
    handleClose(item1, index) {
      if (this.disabled) {
        return;
      }
      this.coReqVos[index].orgReqVos = this.coReqVos[index].orgReqVos.filter(
        (v) => v.orgCode !== item1.orgCode,
      );
      this.$emit('input', this.coReqVos);
    },
    addBtn() {
      this.coReqVos.push({
        orgReqVos: [],
        coBudgetYear: '',
        coBudgetSubjectName: '',
        coBudgetSubjectCode: '',
        coCompanyName: '',
        coCompanyCode: '',
        unionOrgName: '',
        unionOrgCode: '',
      });
      this.$emit('input', this.coReqVos);
    },
    deleteBtn(index) {
      this.coReqVos.splice(index, 1);
      this.$emit('input', this.coReqVos);
    },
    // 获取转结财年数据字典
    getyesOrNoData() {
      request
        .post('/mdm/mdmdictdata/list', {
          dictTypeCode: 'budget_year',
        })
        .then((res) => {
          if (res.success) {
            this.fiscalYearArrList = res.result;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form-item__label {
  font-size: 12px !important;
}
.cost-select {
  position: relative;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }

  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }

  &:hover {
    .clear-icon {
      display: block;
    }
  }
}
.cost-select1 {
  position: relative;
  border: 1px solid #dddfe6;
  border-radius: 5px;
  padding: 5px;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }

  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }

  &:hover {
    .clear-icon {
      display: block;
    }
  }
}
.tag_box{
    margin-right: 5px;
}
.btn {
  float: right;
  margin-left: 10px;
}
</style>
